/**
 * Frontend types for member-role management.
 * Used by the UsersPage, useMemberRoles hook, and related components.
 */

/** System roles available in the application */
export type Role = 'Admin' | 'Organizer' | 'Delegate' | 'Attendee';

/** Option descriptor for role selection UI (radio buttons, dropdowns) */
export interface RoleOption {
  value: Role;
  label: string;
}

/** Available role options for use in radio groups and selects */
export const ROLE_OPTIONS: RoleOption[] = [
  { value: 'Admin', label: 'Admin' },
  { value: 'Organizer', label: 'Organizer' },
  { value: 'Delegate', label: 'Delegate' },
  { value: 'Attendee', label: 'Attendee' },
];

/** A member record with their linked user account data (if any) */
export interface MemberWithUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  status: 'Active' | 'Inactive' | 'Suspended';
  userId: string | null;
  user?: {
    id: string;
    fullName: string;
    email: string;
    role: Role;
  };
}

/** Payload for creating a user account from an existing member */
export interface CreateFromMemberPayload {
  memberId: string;
  role: Role;
  password: string;
}

/** Payload for updating a user's role */
export interface RoleUpdatePayload {
  role: Role;
}

/** Tracks an unsaved role change for a specific member row */
export interface PendingChange {
  memberId: string;
  originalRole: Role;
  newRole: Role;
}
